import { FC } from 'react';

type SpacerProps = {
  height: number;
};

const Spacer: FC<SpacerProps> = ({ height }) => {
  return <div style={{ width: '100%', height }} />;
};

export default Spacer;
